import requisicaoSegura from '@/auth/requisicaoSegura';
import {
  APIResponseListagemAssinaturas,
  APIResponseListagemGiftCards,
  APIResponseRecuperarAssintatura,
  APIResponseRecuperarConsumoAssintatura,
  APIResponseRecuperarDatasAssintatura,
  APIResponseRecuperarPedidoAvulso,
  Assinatura,
  ConsumoAssinaturaContratada,
  PedidoAvulso,
} from './types/pedidos';
import { APIResponse } from './types';

export async function listarMeusGiftCards({
  filtros = undefined,
  paginacao = {
    paginacao: -1,
    pagina: 1,
    ordenacaoCampo: 'dataCadastro',
    ordenacaoOrdem: 'desc',
  },
  filtroData = undefined,
}: {
  filtros?: string;
  paginacao?: {
    paginacao: number;
    pagina: number;
    ordenacaoCampo: string;
    ordenacaoOrdem: string;
  };
  filtroData?: {
    dataInicio?: string;
    dataFim?: string;
  };
}): Promise<APIResponseListagemGiftCards> {
  const responseListagemGiftCards: APIResponseListagemGiftCards =
    await requisicaoSegura({
      endpoint: '/Marketplace/ListarPedidos',
      dataForm: {
        ...paginacao,
        ...filtroData,
        filtros,
      },
    });

  return responseListagemGiftCards;
}

export async function listarMinhasAssinaturas({
  filtros = undefined,
  paginacao = {
    paginacao: -1,
    pagina: 1,
    ordenacaoCampo: 'dataCadastro',
    ordenacaoOrdem: 'desc',
  },
  filtroData = undefined,
}: {
  filtros?: string;
  paginacao?: {
    paginacao: number;
    pagina: number;
    ordenacaoCampo: string;
    ordenacaoOrdem: string;
  };
  filtroData?: {
    dataInicio?: string;
    dataFim?: string;
  };
}): Promise<APIResponseListagemAssinaturas> {
  const responseListagemMinhasAssinaturas: APIResponseListagemAssinaturas =
    await requisicaoSegura({
      endpoint: '/Marketplace/ListarAssinaturas',
      dataForm: {
        ...paginacao,
        ...filtroData,
        filtros,
      },
    });

  return responseListagemMinhasAssinaturas;
}

export async function recuperarDatasAssinatura(
  assinaturaID: string,
): Promise<string[]> {
  const responseRecuperarDatasAssinatura: APIResponseRecuperarDatasAssintatura =
    await requisicaoSegura({
      endpoint: '/Marketplace/SelecionarDatasAssinatura',
      dataForm: {
        assinaturaID,
      },
    });

  return responseRecuperarDatasAssinatura.modelo.datas;
}

export type recuperarAssinaturaProps = {
  assinaturaID: string;
  dataReferencia?: string;
};

export async function recuperarAssinatura(
  dataForm: recuperarAssinaturaProps,
): Promise<Assinatura> {
  const responseRecuperarAssinatura: APIResponseRecuperarAssintatura =
    await requisicaoSegura({
      endpoint: '/Marketplace/SelecionarAssinatura',
      dataForm,
    });

  return responseRecuperarAssinatura.modelo;
}

export async function recuperarConsumoMensalAssinatura(dataForm: {
  assinaturaID: string;
}): Promise<ConsumoAssinaturaContratada> {
  const responseRecuperarAssinatura: APIResponseRecuperarConsumoAssintatura =
    await requisicaoSegura({
      endpoint: '/Marketplace/BuscarDadosConsumoAssinatura',
      dataForm,
    });

  return responseRecuperarAssinatura?.dados?.dadosConsumo ?? {};
}

export type recuperarPedidoAvulsoProps = {
  pedidoID: string;
  planoID: string;
};

export async function recuperarPedidoAvulso(
  dataForm: recuperarPedidoAvulsoProps,
): Promise<PedidoAvulso> {
  const responseRecuperarAssinatura: APIResponseRecuperarPedidoAvulso =
    await requisicaoSegura({
      endpoint: '/Marketplace/SelecionarPedido',
      dataForm,
    });

  return responseRecuperarAssinatura.modelo;
}

export async function informarResgateGiftCardCompradoItem(
  id: string,
): Promise<boolean> {
  const responseRecuperarAssinatura: APIResponse = await requisicaoSegura({
    endpoint: '/Marketplace/ResgatarCodigo',
    dataForm: { id },
  });

  return responseRecuperarAssinatura.sucesso;
}

export async function informarResgateCodigoAssinaturaContratada(
  id: string,
): Promise<boolean> {
  const responseRecuperarAssinatura: APIResponse = await requisicaoSegura({
    endpoint: '/Marketplace/ResgatarCodigoAssinatura',
    dataForm: { id },
  });

  return responseRecuperarAssinatura.sucesso;
}

export async function cancelarAssinatura(
  assinaturaID: string,
): Promise<APIResponse> {
  const responseCancelarAssinatura: APIResponse = await requisicaoSegura({
    endpoint: '/Marketplace/CancelarAssinatura',
    dataForm: { assinaturaID },
  });

  return responseCancelarAssinatura;
}
